import { CustomerDetails, DownloadStatus } from 'src/app/models/customer-details.model';

/** CustomerDetailsState */
export class CustomerDetailsState {
/** persona , processType , customerType */
public customerDetails: CustomerDetails;
/** reason for Termination  */
public cancellationReason: string;
/** isAccountAgent */
public isAccountAgent: boolean;
/** xConversationId */
public xConversationId: string;
/** downloadedStatus */
public downloadedStatus: DownloadStatus;
}


